import { useSelector } from 'react-redux'
import Loader from '@common/src/common/loader/loader'
import { hasPermission } from '@common/src/common/helper'
import Crm from './crm/crm.jsx'
import Welcome from './welcome.jsx'

const DASHBOARD_PERMISSION = 'pulseDashboard'

const Dashboard = () => {
  const { permissions, loading } = useSelector((state) => state.auth)

  if (loading) {
    return <Loader />
  }

  if (hasPermission(permissions, DASHBOARD_PERMISSION)) {
    return <Crm />
  }

  return <Welcome />
}

export default Dashboard
